import React from 'react';
import { Trash2 } from '@onward-delivery/design/icons';
import { MultiCombobox, NumberInput } from '@onward-delivery/design';
import { ALLOCATION_MODES } from './constants';
import { sellableLabel, serialOptionLabel } from './utils';

const OrderSummaryLine = ({ line, mode, options, onQtyChange, onSerialsChange, onRemove, emptyText }) => {
    const serialized = mode === ALLOCATION_MODES.SERIALIZED;

    return (
        <div className="flex flex-col gap-2 border-b border-border px-6 py-3">
            <div className="flex items-center justify-between gap-3">
                <p className="min-w-0 flex-1 truncate text-sm font-semibold text-foreground">
                    {line.description || line.sku}
                </p>
                <div className="flex items-center gap-3">
                    {serialized ? null : (
                        <NumberInput
                            value={line.qty}
                            min={0}
                            max={Number(line.on_hand_count) || 0}
                            onValueChange={(next) => onQtyChange(line, next)}
                            aria-label={`Quantity for ${line.sku}`}
                        />
                    )}
                    {/* A bare glyph, as in the design — a ghost
                        Button's padding and hover box read as a
                        second control next to the stepper. */}
                    <button
                        type="button"
                        onClick={() => onRemove(line)}
                        aria-label={`Remove ${line.sku}`}
                        className="shrink-0 text-muted transition-colors hover:text-destructive focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                    >
                        <Trash2 className="h-4 w-4" />
                    </button>
                </div>
            </div>
            <div className="flex items-center gap-2 text-[11px] text-muted">
                <span className="font-medium">{line.sku}</span>
                <span>•</span>
                <span className="font-semibold">{sellableLabel(line, line.qty)}</span>
            </div>
            {serialized ? (
                <MultiCombobox
                    className="w-full"
                    options={options.map((item) => ({ value: item.item_id, label: serialOptionLabel(item) }))}
                    value={line.item_ids || []}
                    onValueChange={(ids) => onSerialsChange(line, ids)}
                    placeholder="Select serial numbers"
                    searchPlaceholder="Search serial or line ID..."
                    emptyText={emptyText}
                    maxDisplay={3}
                />
            ) : null}
        </div>
    );
};

export default OrderSummaryLine;
